<template>
  <div>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Notes</base-card-heading>
        <base-button modal="#newNoteModal" secondary small>New Note</base-button>
      </template>
      <template v-if="notes.length">
        <base-table>
          <colgroup>
            <col />
            <col />
            <col width="50%" />
          </colgroup>
          <thead>
            <tr>
              <th>Date added</th>
              <th>Added by</th>
              <th>Note</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(note, key) in notes" :key="key">
              <td>{{ $dates.toDateTime(note.createdAt) }}</td>
              <td>{{ note.user.profile.firstName }} {{ note.user.profile.lastName }}</td>
              <td>{{ note.content }}</td>
              <td class="text-right">
                <base-button v-tooltip="'Delete note'" icon-right="trash" small title="Remove note" @click="remove(key)" />
              </td>
            </tr>
          </tbody>
        </base-table>
      </template>
      <template v-else>
        <p class="text-center py-4">No notes have been addded yet.</p>
      </template>
    </base-card>
    <modal-container :id="'newNoteModal'">
      <form @submit.prevent="submit">
        <div class="modal-header">
          <h5 class="modal-title">New Note</h5>
        </div>
        <div class="modal-body">
          <base-field row>
            <base-textarea v-model="payload.content" />
          </base-field>
        </div>
        <div class="modal-footer">
          <base-button data-dismiss="modal">Cancel</base-button>
          <base-button :loading="saving" primary submit>Add</base-button>
        </div>
      </form>
    </modal-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ModalContainer from './ModalContainer.vue'

export default {
  created () {
    this.refresh()
  },

  data: () => ({
    payload: {},
    saving: false
  }),

  name: 'ProjectNotes',

  components: {
    ModalContainer
  },

  computed: {
    notes () {
      return this.project.notes || []
    },

    ...mapGetters({
      schema: 'core/notes/schema'
    }),

    ...mapState({
      note: store => store.core.notes.entity,
      project: store => store.core.projects.entity
    })
  },

  methods: {
    refresh () {
      this.payload = this.$_.cloneDeep(this.schema)
    },

    async remove (index) {
      const note = this.notes[index]

      this.$dialog.confirm('Are you sure you want to delete this note?', async () => {
        await Promise.all([
          this.$store.dispatch('core/projects/notes/pull', note),
          this.$store.dispatch('core/notes/remove', note._id)
        ])
      })
    },

    async submit () {
      this.saving = true

      this.payload.user = this.$auth.user._id
      this.payload.tag = 'project'

      await this.$store.dispatch('core/notes/save', this.payload)
      await this.$store.dispatch('core/projects/notes/add', this.note)

      $('#newNoteModal').modal('hide')

      this.refresh()

      this.saving = false
    }
  }
}
</script>
